module.exports = __webpack_public_path__ + "media/application/images/icons/linkedin-6122e250174d1d3a6c111ee3e7453026.svg";